import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  noSubscriptionsFound: 'You have no subscriptions',
  reSubscribe: 'Resubscribe',
  renewalDate: 'Renewal Date ',
  reactivate: 'Reactivate',
  endDate: 'End Date ',
  expiringSoon: 'Expiring Soon',
  autoRenewal: 'Monthly auto-renewal',
  autoRenewalCanceled:
    'Auto-renewal has been canceled. You will continue to enjoy the benefits of your plan until the end date.',
  cancelSubscription: 'Cancel Subscription',
  cancelSubscriptionConfirm: 'are you sure, you want to cancel subscription?',
  cancelSubscriptionNote:
    'If you cancel now, your subscription will remain active until {{date}} ',
  noValue: 'I did not find enough value in the subscription',
  toExpensive: 'The subscription is too expensive for me',
  hardToUse: 'I found it difficult to use the features',
  noNeedAnymore: 'I no longer need the service',
  anotherReason: 'Other reason',
  requiredReason: 'Please select a reason',
  explainIssue: 'Explain the issue',
  whyCanceling: 'Why do you want to cancel your subscription?',
  requiredComment: 'Please explain the issue',
});
